/**
 * エラーハンドリング共通ライブラリ
 * 統一エラーハンドリング、エラーログ出力
 */

/**
 * HTTPステータスコードからデフォルトメッセージIDを取得するマッピング
 */
const STATUS_CODE_TO_MESSAGE_ID = {
  401: {'code':'E001-0011', 'message':'認証が必要です'}, // 認証が必要です
  403: {'code':'E001-0011', 'message':'認証が必要です'}, // 認証が必要です
  429: {'code':'E000-0008', 'message':'レート制限が超過しています。'}  // レート制限が超過しています。
};

/**
 * APIレスポンスのエラーハンドリング
 * @param {Response} response - fetch APIのResponseオブジェクト
 * @param {Object} responseData - レスポンスボディのJSONデータ
 * @param {string} [defaultErrorMessage] - デフォルトのエラーメッセージ（任意）
 * @returns {Error} エラーオブジェクト
 */
function handleApiError(response, responseData, defaultErrorMessage = 'APIの取得エラー等') {
  // statusCodeを取得（responseData.statusCodeまたはresponse.status）
  const statusCode = responseData.statusCode || response.status || 500;
  
  // 1. レスポンスボディからエラーコードを取得（優先順位順）
  // responseData.error?.code → responseData.data?.message_id
  let errorCode = responseData.error?.code || responseData.data?.message_id;

  
  // エラーメッセージを取得（responseData.error?.messageを優先、なければデフォルト）
  let errorMessage = responseData.error?.message || defaultErrorMessage;
  let errorDetails = responseData.error?.details || {};
  
  // 2. エラーコードが取得できない場合、HTTPステータスコードからデフォルトメッセージIDを決定
  if (!errorCode) {
    errorCode = STATUS_CODE_TO_MESSAGE_ID[statusCode]?.code || 'E005-0004';
    errorMessage = STATUS_CODE_TO_MESSAGE_ID[statusCode]?.message || defaultErrorMessage;
  }
  
  
  // 3. エラーオブジェクトを生成
  const error = new Error(`${errorCode}: ${errorMessage}`);
  error.code = errorCode; // メッセージID
  error.statusCode = statusCode; // HTTPステータスコード
  error.details = errorDetails;
  
  
  return error;
}

module.exports = {
  // APIエラーハンドリング
  handleApiError,
  
  // エラーハンドリング
  handleError: (error) => {
    throw new Error('Not implemented');
  },
  
  // エラーログ出力
  logError: (error) => {
    throw new Error('Not implemented');
  },
  
  // エラーコード取得
  getErrorCode: (error) => {
    throw new Error('Not implemented');
  }
};

